<template>
<v-layout row justify-center class="billingModule">
  <v-flex md3 class="sidebar">
    <aside>
      <ul>
        <li>
          <router-link to="/forms/employee-registration">Employee Register</router-link>
        </li>
        <li>
          <router-link to="/forms/visit-register" >Visit Register</router-link>
        </li>
        <li >
          <router-link to="/forms/monthly-report" >Monthly Report</router-link>
        </li>
        <li >
          <router-link to="/forms/patient-list" >Patient List</router-link>
        </li>
        <li >
          <router-link to="/forms/brand-list" >Brand List</router-link>
        </li>

        <li class="active" >
          <router-link to="/forms/pharma-company-list" >Pharma Company List</router-link>
        </li>

        <!-- <li>
          <router-link to="/forms/periodic-brand-count" >Periodic Brand Count</router-link>
        </li> -->
      </ul>
    </aside>
  </v-flex md3>
  <v-flex md9 pl-3 pr-3>
  <v-container>
    <v-layout row wrap>
      <v-flex xs6>
      <h1 class="title">Pharma Company List</h1>
      </v-flex>

           <v-flex xs6>
  <el-input
    placeholder="Search Pharma Company"
    prefix-icon="el-icon-search"
    style="width:340px"
    v-model="searchTerm"
    @change="onSearchChange"
    >
  </el-input>

      </v-flex>

    </v-layout>
  </v-container>


    <v-layout row wrap>
    <el-table
      v-loading="isLoading"
      :data="responseData"
      style="width: 100%">

      <el-table-column
        prop="name"
        label="Company Name"
        >
      </el-table-column>

    </el-table>
  </v-layout>


      <v-container>
    <v-layout row wrap>
      <v-flex xs9>
        <!-- TODO: Total from API? -->
          <el-pagination
        layout="prev, pager, next"
        :total="this.totalCount"
        style="text-align:center"
        page-size="30"
        @current-change="changePage"
        >
      </el-pagination>
      </v-flex>
    </v-layout>
</v-container>

  </v-flex>
</v-layout>
</template>
<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api } from '../api.js';
import {formatDate} from '../util.js'
import {get, post} from 'axios';
const queryString = require('query-string');

export default {
  userName: '',
  components: {
    // NOTE: don't forget to add components here after import
    // sample in next line
    // VueGoogleAutocomplete
  },
  beforeRouteLeave: (to,from,next)=>{
    // NOTE: add any action to be performed before leaving the route here
    // the next() is important
    // so add everything before next()
    // sample in next line
    // console.log("Loggin before leaving route");
    next()
  },
  data() {
    return {
      isLoading:false,
      snackbar: false,
      snackbarColor: '',
      mode: '',
      timeout: 6000,
      snackbarText: 'Hello, I\'m a snackbar',
      searchTerm:'',
      dateRange:{},
      currentPage:1,
      responseData:[],
        datePickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    } // return statement end
    }, // data() end
  mounted() {
    // NOTE: add actions to be performed on-mount
this.getData();
this.$on('pick', function (msg) {
  console.log(msg)
})

},
  methods: {
    changePage(pageNo){
      this.currentPage = pageNo;
      this.getData()
    },
    onSearchChange(){
      this.getData();
    },
    getData(dateRange=null){
      this.isLoading = true;
      // /employee_register?clinic_id=1&from_date=2018-08-01&to_date=2018-08-10'
      const requestQueryString = {
        clinic_id:localStorage.clinic_id,
        page_no:this.currentPage,
      }

      if(this.searchTerm.length){
       requestQueryString.search =  this.searchTerm;
      }

      if(dateRange && dateRange.length <= 2){
        requestQueryString.from_date = formatDate(dateRange[0])
        requestQueryString.to_date = formatDate(dateRange[1])
      }

      get(api + `/pharma_company_list?${queryString.stringify(requestQueryString)}`)
        .then(res => {
          console.log(res);
          this.responseData = res.data.companies
          this.totalCount = res.data.count;

        })
      this.isLoading = false;

    }
  }
}
</script>

<style lang="css" scoped>

.title{
  margin-top: 10px;
}
.el-input {
  width: 10px;
  margin: auto;
}
.addWrapper {
  text-align: center;
    display: flex;
    justify-content: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    align-items: center;
}
.add {
  /* padding: 3rem 0; */
}
.billingModule {
  min-height: 99vh;
}

#example-1 {
  font-size: 20px;
  padding: 20px;
  margin-left: 1.5rem;
}

#example-2 {
  /*padding: 20px;*/
}

#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}

.listOfCharges {
  display: flex;
}

#partiallyPaid {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
}

/* .card__title {
  background-color: #018FFF;
  color: white;
  font-size: 80px;
} */

ul {
  list-style: none;
}

.fa-times-circle-o {
  color: #8080808a;
}

.invoiceTotals {
  padding: 20px;
  margin-left: 1.5rem;
  text-align: right;
  padding-right: 5rem;
}

.invoiceTotals>h3 {
  margin: 10px 0px;
}

.sidebar {
  background-color: #383B3F;
  color: #fff;
}

.sidebar ul li {
  padding: 1rem;
}

.sidebar ul li a {
  color: white;
  text-decoration: none;
}

.sidebar .active {
  background-color: #F2994A;
}

.patient_profile>h4 {
  padding: 10px 10px 2px 10px;
}

.patient_profile>h5 {
  padding: 0 10px 10px;
}

.fa-inr {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.card__actions {
  justify-content: flex-start;
  padding: 16px;
}

.autocompleteSelect {
  width: 65%;
}
</style>



// WEBPACK FOOTER //
// src/components/FormPharmaCompanyList.vue